import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {
  configPadraoSucesso: MatSnackBarConfig = {
    duration: 2000,
    verticalPosition: 'top',
    horizontalPosition: 'end',
    panelClass: ['snackbar', 'green-snackbar'],
  };

  configPadraoErro: MatSnackBarConfig = {
    verticalPosition: 'top',
    horizontalPosition: 'end',
    panelClass: ['snackbar', 'red-snackbar'],
  };

  configPadraoAlerta: MatSnackBarConfig = {
    duration: 5000,
    verticalPosition: 'top',
    horizontalPosition: 'end',
    panelClass: ['snackbar', 'yellow-snackbar'],
  };

  constructor(private snackBar: MatSnackBar) {}

  exibirSucesso(mensagem: string, acao: string = 'Ok', config: MatSnackBarConfig = this.configPadraoSucesso) {
    this.snackBar.open(mensagem, acao, config);
  }

  exibirErro(mensagem: string, acao: string = 'Ok', config: MatSnackBarConfig = this.configPadraoErro) {
    this.snackBar.open(mensagem, acao, config);
  }

  exibirAlerta(mensagem: string, acao: string = 'Ok', config: MatSnackBarConfig = this.configPadraoAlerta) {
    this.snackBar.open(mensagem, acao, config);
  }
}
